/**
 * Ticket Followers Service - API calls para seguidores de tickets
 */

import { api } from '@/lib/api';
import type { TicketFollowerResponse, AddTicketFollowerRequest, BulkAddTicketFollowersRequest } from '@troia-v3/types';

export const ticketFollowersService = {
  async getByTicketId(ticketId: string): Promise<TicketFollowerResponse[]> {
    const response = await api.get(`ticket-followers/ticket/${ticketId}`);
    return response.data.data;
  },

  async addFollower(data: AddTicketFollowerRequest): Promise<TicketFollowerResponse> {
    const response = await api.post('ticket-followers', data);
    return response.data.data;
  },

  async addFollowersBulk(data: BulkAddTicketFollowersRequest): Promise<TicketFollowerResponse[]> {
    const response = await api.post('ticket-followers/bulk', data);
    return response.data.data;
  },

  async removeFollower(ticketId: string, followerType: string, followerId: string): Promise<void> {
    await api.delete(`ticket-followers/${ticketId}/${followerType}/${followerId}`);
  },
};
